/**
 * Array of all permission type names.
 * Used for type generation and permission management.
 */
export const PERMISSION_TYPES = Object.freeze([
  'Activities',
  'Analytics',
  'Categories',
  'Credits',
  'Credit_Types',
  'Orders',
  'Permissions',
  'Permission_Groups',
  'Posts',
  'Submissions',
  'Users',
] as const);
